import { render } from "./GiftVoucherTargetSelector.vue?vue&type=template&id=cf1cf282&scoped=true"
import script from "./GiftVoucherTargetSelector.vue?vue&type=script&lang=js"
export * from "./GiftVoucherTargetSelector.vue?vue&type=script&lang=js"

import "./GiftVoucherTargetSelector.vue?vue&type=style&index=0&id=cf1cf282&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf1cf282"]])

export default __exports__